import { classNames } from "../App";

export default function CustomSelect({ className, options, register, value, onChange, placeholder }) {
    return (
        <div className="relative">
            <select
                className={classNames(
                    className,
                    'appearance-none pl-4 pr-8 py-2 text-base rounded-lg border bg-white border-neutral-border focus:outline-none text-neutral-400 w-full'
                )}
                value={value}
                onChange={onChange}
                {...register}
            >
                {
                    placeholder && <option value="">{placeholder}</option>
                }
                {options?.map((option, index) => (
                    <option key={index} value={option.id}>
                        {option.name}
                    </option>
                ))}
            </select>
            {/* Dropdown Icon */}
            <div className="absolute inset-y-0 right-2 flex items-center pointer-events-none">
                <svg
                    className="w-5 h-5 text-gray-400"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                </svg>
            </div>
        </div>

    )
}